import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { loadRoles } from '../actions';

/**
 * Re-read the current user's role whenever they navigate to another page.
 *
 * The role (and so every permission gate) is otherwise loaded once per
 * organization per page load. If it changes mid-session, e.g. an admin turns
 * off Cancel Trips or moves the user to another role, gated CTAs kept acting on
 * the old permissions until a full reload (TS-9877). Refreshing on navigation
 * picks up the change by the time the user reaches the next page.
 *
 * Skips the initial render (the active-organization effect in App already loads
 * the role) and does nothing until an organization is active. A failed refresh
 * keeps the role already loaded.
 *
 * @param {string} [orgResourceId] - the active organization; no refresh without one
 * @returns {void}
 */
export const useRefreshRolesOnNavigation = (orgResourceId) => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const lastPathnameRef = useRef(pathname);

  useEffect(() => {
    if (lastPathnameRef.current === pathname) return;
    lastPathnameRef.current = pathname;

    if (orgResourceId) dispatch(loadRoles({ isRefresh: true }));
  }, [pathname, orgResourceId, dispatch]);
};
